import {
  Opportunity as OpportunityType,
  JourneyActivity,
  MobileDeviceOS,
  MobileAppInstallationStatus,
} from '@audibene/ta.utils-opportunity'
import { OpportunityStatus } from 'constants/'
import { FocusReasonDetail } from 'hooks'

interface OpportunityLifecycle {
  closed_date_lost: string
  created_at: string
  customer_gid: string
  date_confirmation_receipt: string
  end_of_trial_period: string
  financial_notes: string
  fitter_gid: string
  id: string
  is_closed: string
  opportunity_gid: string
  owner_gid: string
  payment_date: string
  return_date: string
  status: OpportunityStatus
  updated_at: string
}

interface Opportunity extends Omit<OpportunityType, 'focusReasons'> {
  journeyActivities?: JourneyActivity[]
  focusReasons: FocusReasonDetail[]
}

const pairingAppStatuses = {
  NOT_PAIRED: 'NOT_PAIRED',
  PAIRED: 'PAIRED',
  PAIRED_WITH_TELECARE: 'PAIRED_WITH_TELECARE',
} as const

type PairingAppStatuses = typeof pairingAppStatuses[keyof typeof pairingAppStatuses]

const appPairingInstallStatuses = {
  ANDROID: MobileDeviceOS.ANDROID,
  DEFAULT: 'DEFAULT',
  IOS: MobileDeviceOS.IOS,
  NOT_PAIRED: pairingAppStatuses.NOT_PAIRED,
  PAIRED: pairingAppStatuses.PAIRED,
  PAIRED_WITH_TELECARE: pairingAppStatuses.PAIRED_WITH_TELECARE,
  UNKNOWN: MobileAppInstallationStatus.UNKNOWN,
} as const

type AppPairingInstallStatuses = typeof appPairingInstallStatuses[keyof typeof appPairingInstallStatuses]

export { appPairingInstallStatuses, pairingAppStatuses }

export type { AppPairingInstallStatuses, PairingAppStatuses, Opportunity, OpportunityLifecycle }
